(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this._resizeHandler = null;
    }
    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.header_wrapper = document.querySelector('.header-wrapper');
      this.transparent = this.hasAttribute('data-transparent');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'on-scroll-down' ||
        this.getAttribute('data-sticky-type') === 'shrink-logo';
      this.headerBounds = {};
      this.transparent && this.header_wrapper.classList.add('is-transparent');
      this.setHeaderHeight();

      // Resize fix
      this.debouncedSetHeaderHeight = this.debounce(this.setHeaderHeight.bind(this), 100);
      window.addEventListener('resize', this.debouncedSetHeaderHeight);

      // matchMedia fix with rAF
      window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
        requestAnimationFrame(() => this.setHeaderHeight());
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.debouncedSetHeaderHeight);
      if (this._simpleScrollHandler) {
        document.removeEventListener('scroll', this._simpleScrollHandler);
      }
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header_wrapper.offsetHeight}px`);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
      if (this.getAttribute('data-sticky-type') === 'on-scroll-down') {
        this.simpleStickyScroll();
      }
    }

    simpleStickyScroll() {
      this._simpleScrollHandler = () => {
        const scrolledPage = Math.round(window.pageYOffset);
        if (scrolledPage > 0) {
          this.header.classList.add('sticky-anime');
        } else {
          this.header.classList.remove('sticky-anime');
        }
      };

      document.addEventListener('scroll', this._simpleScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'is-animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'is-animate');
    }

    debounce(func, wait = 100) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
